import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScCards = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;

  .title {
    ${typography['headline2']};
    text-transform: uppercase;
    @media (${device.mobile}) {
      ${typography['headline2mobile']};
    }
  }

  .wrapper-img {
    display: flex;
    gap: 16px;
    .card-item {
      position: relative;
      z-index: 1;
      color: ${({ theme }) => theme.brownColor};

      .wrapper-text {
        display: flex;
        position: absolute;
        flex-direction: column;
        z-index: 2;
        right: 12px;
        top: 12px;
        text-align: end;
        text-transform: uppercase;
        gap: 4px;
        .card-title {
          ${typography['caption3bold']};
          @media (${device.mobile}) {
            ${typography['captionbold']};
          }
        }
        .card-description {
          white-space: pre-line;
          ${typography['caption5bold']};
          @media (${device.mobile}) {
            ${typography['caption4bold']};
          }
        }
      }
    }
    @media (${device.mobile}) {
      flex-direction: column;
    }
  }
`;
